export default __webpack_public_path__ + "static/media/logo-bnb-border-white.2179fae1.svg";